export const contentSelector = (state) => state.content.contentResult.content;
export const hitsSelector = (state) => state.content.contentResult.hits;



// WEBPACK FOOTER //
// ./src/state/modules/content/selectors.js